import { render, staticRenderFns } from "./PrioritizationLegend.vue?vue&type=template&id=c9abec38&scoped=true"
import script from "./PrioritizationLegend.vue?vue&type=script&lang=ts"
export * from "./PrioritizationLegend.vue?vue&type=script&lang=ts"
import style0 from "./PrioritizationLegend.vue?vue&type=style&index=0&id=c9abec38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9abec38",
  null
  
)

export default component.exports